
import { CommonService } from "../../../services/common.service";
const commonServiceObj = new CommonService(); export const chart1 = {
  credits: { enabled: false },
  chart: { type: "column" },
  title: { text: "" },
  xAxis: { categories: ["All"] },
  yAxis: [
    {
      min: 0,
      //max: 100,
      title: { text: "Percentage" },
      stackLabels: { enabled: false },
      labels: {
        style: { fontSize: "12px" },
        format: "{value}%"
      }
    }
  ],
  marker: { enabled: false },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>"
  },
  plotOptions: {
    column: { stacking: "normal", dataLabels: { enabled: false } }
  },
  series: [
    //{ name: "Utilized", color: "#C6CDD4", data: [15] },
    { name: "Utilized", color: "#007FD8", data: [80], showInLegend: false }
  ]
};

export const chart2 = {
  credits: { enabled: false },
  chart: { zoomType: "xy", type: "column" },
  title: { text: "", align: "left" },
  xAxis:
  {
    categories: ["North", "South", "East", "West"],
    crosshair: true,
    labels: {
      style: { fontSize: "12px" },
      //format: "{value}%"
      formatter: function () {
        return commonServiceObj.settingFormater(this.value)
      }
    },
  }
  ,
  yAxis: [
    {
      // Primary yAxis
      labels: {
        style: { fontSize: "12px" },
        format: "{value}%"
      },
      title: { text: "Percentage" }
    },
    {
      // Secondary yAxis
      title: { text: "Storage capacity (Thousand Cubic Feet)" },
      labels: { format: "{value}", style: { fontSize: "12px" } },
      opposite: true
    }
  ],
  plotOptions: {
    line: {
      marker: {
        enabled: false
      }
    },
    column: {
      stacking: "normal"
    }
  },
  tooltip: { shared: true },
  legend: {
    enabled: false,
    itemMarginTop: 0,
    itemMarginBottom: -20,
    align: "center",
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },

  series: [
    {
      name: "Available ",
      data: [],
      stack: "A",
      color: "#c6cdd4",
      tooltip: { valueSuffix: "%" }
    },
    {
      name: "Utilized",
      data: [],
      stack: "A",
      color: "#007fd8",
      tooltip: { valueSuffix: "%" }
    },

    {
      name: "Total Capacity",
      data: [],
      stack: "B",
      yAxis: 1,
      color: "#909dc0"
      // tooltip: { valueSuffix: "crore" }
    },
    {
      type: "line",
      name: "Target",
      showInLegend: false,
      data: [],
      dashStyle: "ShortDash",
      color: "#979797",
      tooltip: { valueSuffix: "%" }
    }
  ]
};
